export default {"src":"/_next/static/media/logo-icon.89409daa.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};